import type { TFunction } from 'i18next';
import { z } from 'zod';
import { MIN_MULTI_DAY_SELECTED_DATES } from '../multi-day-dates-calendar/multi-day-dates-calendar.types';

const createRequiredStringSchema = (message: string) =>
  z.preprocess((value) => (value == null ? '' : String(value)), z.string().min(1, message));

const createMultiDayDayBlockSchema = (t: TFunction) =>
  z.object({
    date: z.string().min(1),
    startTime: createRequiredStringSchema(t('work_form.multi_day.day_blocks.start_time.required')),
    endTime: createRequiredStringSchema(t('work_form.multi_day.day_blocks.end_time.required')),
    breakMinutes: createRequiredStringSchema(t('work_form.multi_day.day_blocks.break.required')),
  });

export const createMultiDayWorkFormSchema = (t: TFunction) =>
  z
    .object({
      jobId: createRequiredStringSchema(t('work_form.multi_day.validation.template.required')),
      department: createRequiredStringSchema(
        t('work_form.multi_day.validation.department.required')
      ),
      isFreelance: z.boolean().optional(),
      isTempwork: z.boolean().optional(),
      isEmployee: z.boolean().optional(),
      multiDayDates: z
        .array(z.string())
        .min(
          MIN_MULTI_DAY_SELECTED_DATES,
          t('work_form.multi_day.validation.dates.min', { count: MIN_MULTI_DAY_SELECTED_DATES })
        ),
      multiDayDayBlocks: z
        .array(createMultiDayDayBlockSchema(t))
        .min(
          MIN_MULTI_DAY_SELECTED_DATES,
          t('work_form.multi_day.validation.dates.min', { count: MIN_MULTI_DAY_SELECTED_DATES })
        ),
    })
    .refine(
      (data) => data.isFreelance === true || data.isTempwork === true || data.isEmployee === true,
      {
        message: t('work_form.multi_day.validation.employment_type.required'),
        path: ['isFreelance'],
      }
    );
